var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 15S6.25 5 15 5s13.75 10 13.75 10-5 10-13.75 10S1.25 15 1.25 15z",
    stroke: "#474747",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z",
    stroke: "#474747",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzAgMzAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjI1IDE1QzEuMjUgMTUgNi4yNSA1IDE1IDVDMjMuNzUgNSAyOC43NSAxNSAyOC43NSAxNUMyOC43NSAxNSAyMy43NSAyNSAxNSAyNUM2LjI1IDI1IDEuMjUgMTUgMS4yNSAxNVoiIHN0cm9rZT0iIzQ3NDc0NyIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTUgMTguNzVDMTcuMDcxMSAxOC43NSAxOC43NSAxNy4wNzExIDE4Ljc1IDE1QzE4Ljc1IDEyLjkyODkgMTcuMDcxMSAxMS4yNSAxNSAxMS4yNUMxMi45Mjg5IDExLjI1IDExLjI1IDEyLjkyODkgMTEuMjUgMTVDMTEuMjUgMTcuMDcxMSAxMi45Mjg5IDE4Ljc1IDE1IDE4Ljc1WiIgc3Ryb2tlPSIjNDc0NzQ3IiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgEye as ReactComponent };